const header = document.querySelector('.js-header');

if (header) {

    const headerHeight = header.clientHeight;
    let lastScrollTop = 0,
        delta = 30;

    const addtocartBar = document.querySelector('.js-addtocart-bar'),
        addtocartBtn = document.querySelector('.js-addtocart-button');

    window.onscroll = () => {
        if(document.body.classList.contains('locked')) {
            return;
        }

        if(document.documentElement.scrollTop > headerHeight){
            header.classList.remove('top');
            setTimeout(() => {
                header.classList.add('scrolled');
            }, 100);
        } else {
            header.classList.add('top');
            header.classList.remove('scrolled');
        }

        if(addtocartBtn) {
            if (document.documentElement.scrollTop > addtocartBtn.offsetTop) {
                addtocartBar.classList.add('show');
            } else {
                addtocartBar.classList.remove('show');
            }
        }

        var nowScrollTop = document.documentElement.scrollTop;
        if(Math.abs(lastScrollTop - nowScrollTop) >= delta){
            if (nowScrollTop >= lastScrollTop){
                header.classList.remove('scrolledUp');
                if(addtocartBtn) {
                    addtocartBar.classList.remove('scrolledUp');
                }
            } else {
                header.classList.add('scrolledUp');
                if(addtocartBtn) {
                    addtocartBar.classList.add('scrolledUp');
                }
            }
            lastScrollTop = nowScrollTop;
        }
    };

    window.addEventListener('pageshow', function() {
        const videos = document.querySelectorAll('video');

        videos.forEach(function(video) {
          video.play();
        });
    });
}
